import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserPreference } from '@rd/types';
import { Observable } from 'rxjs';
import { UpdatePointsAccountId } from '../../store/actions/user-preference.actions';
import { getUserPreferences } from '../../store/reducers';
import { UserPreferenceState } from '../../store/reducers/user-preference.reducer';

@Injectable()
export class UserPreferenceFacade {
  constructor(private store: Store<UserPreferenceState>) {}

  userPreferences$: Observable<UserPreference> =
    this.store.select(getUserPreferences);

  updatePointsAccountId(pointsAccountId: string): void {
    this.store.dispatch(new UpdatePointsAccountId(pointsAccountId));
  }
}
